import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import constant from "../../../constant/constant";

const MySwal = withReactContent(Swal);

const AutoPrescriptionPopup = ({
  instruction = [],
  onConfirm,
  btnClass = " btn  cursor-pointer  search-btn",
  params,
}) => {
  let role = localStorage.getItem("user_login_type_role");
  const showPopup = () => {
    // pick correct list safely
    const list =
      params?.isPriestMeeting == "true"
        ? constant?.auto_rx_instructionPriest || []
        : instruction || [];

    // build HTML content
    const htmlContent = `
    <div style="
      max-height: 300px;
      overflow-y: auto;
      text-align: left;
      padding: 0.5rem 0;
      font-size: 14px;
    ">
      ${list
        .map(
          (item, index) =>
            `<p style="margin-bottom: 8px;"><strong>${
              index + 1
            }.</strong> ${item}</p>`
        )
        .join("")}
    </div>
  `;

    MySwal.fire({
      title:
        role === "4" || params?.isPriestMeeting == "true"
          ? "Pastoral Summary"
          : "Auto Prescription",
      html: htmlContent,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
      customClass: {
        popup: "swal_wide",
      },
    }).then((result) => {
      if (result.isConfirmed && typeof onConfirm === "function") {
        onConfirm("tempPres");
      }
    });
  };

  // const showPopup = () => {
  //   MySwal.fire({
  //     title: `${role == "4" ? "Pastoral Summary" : "Auto Prescription"} `,
  //     html:
  //       params?.isPriestMeeting == "true"
  //         ? `
  //       <div style="
  //         max-height: 300px;
  //         overflow-y: auto;
  //         text-align: left;
  //         padding: 0.5rem 0;
  //         font-size: 14px;
  //       ">
  //         ${auto_rx_instructionPriest
  //           .map(
  //             (item, index) =>
  //               `<p style="margin-bottom: 8px;"><strong>${
  //                 index + 1
  //               }.</strong> ${item}</p>`
  //           )
  //           .join("")}
  //       </div>
  //     `
  //         : `
  //       <div style="
  //         max-height: 300px;
  //         overflow-y: auto;
  //         text-align: left;
  //         padding: 0.5rem 0;
  //         font-size: 14px;
  //       ">
  //         ${instruction
  //           .map(
  //             (item, index) =>
  //               `<p style="margin-bottom: 8px;"><strong>${
  //                 index + 1
  //               }.</strong> ${item}</p>`
  //           )
  //           .join("")}
  //       </div>
  //     `,
  //     showCancelButton: true,
  //     cancelButtonText: "Cancel",
  //     confirmButtonText: "Confirm",
  //     customClass: {
  //       popup: "swal_wide", // Optional: add custom width in CSS
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed && typeof onConfirm === "function") {
  //       onConfirm("tempPres");
  //     }
  //   });
  // };

  return (
    <>
      {role == "4" || params?.isPriestMeeting == "true" ? (
        <button
          className={`${btnClass}`}
          onClick={showPopup}
          type="button"
          style={{
            background: "#e33f29d6",
            cursor: "pointer",
          }}
        >
          <img
            src="/assets/images/icon/priestIcon.png"
            className="img-fluid object-fit-contain"
            style={{ height: 20 }}
            alt="Prescription Icon"
          />
        </button>
      ) : (
        <button
          className={`${btnClass}`}
          onClick={showPopup}
          type="button"
          style={{
            background: "#216fc8",
            cursor: "pointer",
          }}
        >
          <img
            src="/assets/images/icon/trxn.png"
            className="img-fluid object-fit-contain"
            style={{ height: 20 }}
            alt="Prescription Icon"
          />
        </button>
      )}
    </>
  );
};

export default AutoPrescriptionPopup;
